import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex--wrap flex--gap-medium mt-16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Filtering by:", -1 /* HOISTED */)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.active_dropdown_filters.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_status.active, (status) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-status-' + status.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( status, 'project_status' ))
          }, _toDisplayString(status.label), 9 /* TEXT, PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_type.active, (type) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-type-' + type.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( type, 'project_status' ))
          }, _toDisplayString(type.label), 9 /* TEXT, PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_location.active, (location) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-location-' + location.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( location, 'project_location' ))
          }, _toDisplayString(location.label), 9 /* TEXT, PROPS */, _hoisted_5))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.media_types.active, (media_type) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-media-type-' + media_type.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( media_type, 'media_types' ))
          }, _toDisplayString(media_type.label), 9 /* TEXT, PROPS */, _hoisted_6))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.completion_date.active, (option) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-completion-date-' + option.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( option, 'completion_date' ))
          }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_7))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.production_office.active, (office) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-production-office-' + office.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( office, 'production_office' ))
          }, _toDisplayString(office.label), 9 /* TEXT, PROPS */, _hoisted_8))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.client.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-client-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'client' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_9))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.developer.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-developer-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'developer' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_10))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.development_consultant.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-development-consultant-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'development_consultant' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_11))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.brand_partner.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-brand-partner-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'brand_partner' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_12))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.creative_agency.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-creative-agency-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'creative_agency' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_13))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sales_marketing.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-sales-marketing-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'sales_marketing' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_14))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hospitality_operator.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-hospitality-operator-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'hospitality_operator' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_15))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.architect.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-architect-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'architect' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_16))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.landscape_architect.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-landscape-architect-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'landscape_architect' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_17))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.interior_design.active, (company) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-interior-design-' + company.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( company, 'interior_design' ))
          }, _toDisplayString(company.label), 9 /* TEXT, PROPS */, _hoisted_18))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_manager.active, (user) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-project-manager-' + user.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( user, 'project_manager' ))
          }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_19))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.client_services.active, (user) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-client-services-' + user.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( user, 'client_services' ))
          }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_20))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lead_artist.active, (user) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-lead-artist-' + user.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( user, 'lead_artist' ))
          }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_21))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.artist.active, (user) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-artist-' + user.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( user, 'artist' ))
          }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_22))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.business_development.active, (user) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-business-director-' + user.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( user, 'business_development' ))
          }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_23))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.published.active, (option) => {
          return (_openBlock(), _createElementBlock("button", {
            key: 'active-published-option-' + option.value,
            class: "kappa b icon-end icon-end--close",
            onClick: $event => ($setup.handleRemoveActiveFilterValue( option, 'published' ))
          }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_24))
        }), 128 /* KEYED_FRAGMENT */)),
        ($setup.active_dropdown_filters.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "kappa b icon-end icon-end--close",
              onClick: $setup.handleRemoveAllFilters
            }, " Clear all "))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}